//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { ApiClientBase } from './ApiClientBase';

export class BuildVersionClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    buildVersion( cancelToken?: CancelToken): Promise<YlAssembliesVersionInfo[]> {
        let url_ = this.baseUrl + "/api/common/build-version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuildVersion(_response);
        });
    }

    protected processBuildVersion(response: AxiosResponse): Promise<YlAssembliesVersionInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<YlAssembliesVersionInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<YlAssembliesVersionInfo[]>(null as any);
    }
}

export class HealthStatusClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getHealthStatus( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/common/health-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHealthStatus(_response);
        });
    }

    protected processGetHealthStatus(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getHealthDeep( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/common/health/deep";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHealthDeep(_response);
        });
    }

    protected processGetHealthDeep(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ContentfulLabelsClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getTranslations(namespace: string, lang: string, cancelToken?: CancelToken): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/translations/{namespace}/{lang}";
        if (namespace === undefined || namespace === null)
            throw new Error("The parameter 'namespace' must be defined.");
        url_ = url_.replace("{namespace}", encodeURIComponent("" + namespace));
        if (lang === undefined || lang === null)
            throw new Error("The parameter 'lang' must be defined.");
        url_ = url_.replace("{lang}", encodeURIComponent("" + lang));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTranslations(_response);
        });
    }

    protected processGetTranslations(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }
}

export class OrderPaymentStatusClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    checkOrderPaymentStatusInShoppingAPI(orderId: string, cancelToken?: CancelToken): Promise<PaymentStatusViewModel> {
        let url_ = this.baseUrl + "/api/order-payment-status/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckOrderPaymentStatusInShoppingAPI(_response);
        });
    }

    protected processCheckOrderPaymentStatusInShoppingAPI(response: AxiosResponse): Promise<PaymentStatusViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PaymentStatusViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentStatusViewModel>(null as any);
    }
}

export class ShoppingAPIRegistrationClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    signUpInShopping( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/shopping-sign-up";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignUpInShopping(_response);
        });
    }

    protected processSignUpInShopping(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VoucherAvailabilityClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    validateAndApplyVoucher(code: string, cancelToken?: CancelToken): Promise<PromoVoucherEntryResponseViewModel> {
        let url_ = this.baseUrl + "/api/validate-and-apply-voucher/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateAndApplyVoucher(_response);
        });
    }

    protected processValidateAndApplyVoucher(response: AxiosResponse): Promise<PromoVoucherEntryResponseViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PromoVoucherEntryResponseViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PromoVoucherEntryResponseViewModel>(null as any);
    }
}

export class EnrollmentConfigurationClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getEnrollmentConfigsForCountry(countryIsoCode: string, cancelToken?: CancelToken): Promise<EnrollmentConfigResponse> {
        let url_ = this.baseUrl + "/api/enrollment-config/{countryIsoCode}/tags";
        if (countryIsoCode === undefined || countryIsoCode === null)
            throw new Error("The parameter 'countryIsoCode' must be defined.");
        url_ = url_.replace("{countryIsoCode}", encodeURIComponent("" + countryIsoCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnrollmentConfigsForCountry(_response);
        });
    }

    protected processGetEnrollmentConfigsForCountry(response: AxiosResponse): Promise<EnrollmentConfigResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EnrollmentConfigResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrollmentConfigResponse>(null as any);
    }
}

export class DocumentsClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getDocuments( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/documents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocuments(_response);
        });
    }

    protected processGetDocuments(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    uploadDocuments(files: FileParameter[] | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadDocuments(_response);
        });
    }

    protected processUploadDocuments(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteDocument(originalFileName: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/documents/{originalFileName}";
        if (originalFileName === undefined || originalFileName === null)
            throw new Error("The parameter 'originalFileName' must be defined.");
        url_ = url_.replace("{originalFileName}", encodeURIComponent("" + originalFileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDocument(_response);
        });
    }

    protected processDeleteDocument(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class CountriesClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCountriesAndLanguages( cancelToken?: CancelToken): Promise<CountriesAndLanguagesViewModel> {
        let url_ = this.baseUrl + "/api/countries/all-countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCountriesAndLanguages(_response);
        });
    }

    protected processGetCountriesAndLanguages(response: AxiosResponse): Promise<CountriesAndLanguagesViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountriesAndLanguagesViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountriesAndLanguagesViewModel>(null as any);
    }

    getCountries(locale: string, cancelToken?: CancelToken): Promise<CountriesViewModel> {
        let url_ = this.baseUrl + "/api/countries/all-countries/{locale}";
        if (locale === undefined || locale === null)
            throw new Error("The parameter 'locale' must be defined.");
        url_ = url_.replace("{locale}", encodeURIComponent("" + locale));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCountries(_response);
        });
    }

    protected processGetCountries(response: AxiosResponse): Promise<CountriesViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CountriesViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountriesViewModel>(null as any);
    }

    getLanguages(isoCode: string, cancelToken?: CancelToken): Promise<LanguageViewModel[]> {
        let url_ = this.baseUrl + "/api/countries/languages/{isoCode}";
        if (isoCode === undefined || isoCode === null)
            throw new Error("The parameter 'isoCode' must be defined.");
        url_ = url_.replace("{isoCode}", encodeURIComponent("" + isoCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: AxiosResponse): Promise<LanguageViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LanguageViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LanguageViewModel[]>(null as any);
    }

    getAllSuburbs( cancelToken?: CancelToken): Promise<SuburbModel[]> {
        let url_ = this.baseUrl + "/api/countries/all-suburbs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSuburbs(_response);
        });
    }

    protected processGetAllSuburbs(response: AxiosResponse): Promise<SuburbModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuburbModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuburbModel[]>(null as any);
    }

    getStatesFromPostalCode(countryIso2: string, postalCode: string, cancelToken?: CancelToken): Promise<StateViewModel[]> {
        let url_ = this.baseUrl + "/api/countries/{countryIso2}/postalCodes/{postalCode}/states";
        if (countryIso2 === undefined || countryIso2 === null)
            throw new Error("The parameter 'countryIso2' must be defined.");
        url_ = url_.replace("{countryIso2}", encodeURIComponent("" + countryIso2));
        if (postalCode === undefined || postalCode === null)
            throw new Error("The parameter 'postalCode' must be defined.");
        url_ = url_.replace("{postalCode}", encodeURIComponent("" + postalCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatesFromPostalCode(_response);
        });
    }

    protected processGetStatesFromPostalCode(response: AxiosResponse): Promise<StateViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<StateViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StateViewModel[]>(null as any);
    }

    getAllCities(iso2Code: string, cancelToken?: CancelToken): Promise<CityModel[]> {
        let url_ = this.baseUrl + "/api/countries/{iso2Code}/cities";
        if (iso2Code === undefined || iso2Code === null)
            throw new Error("The parameter 'iso2Code' must be defined.");
        url_ = url_.replace("{iso2Code}", encodeURIComponent("" + iso2Code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCities(_response);
        });
    }

    protected processGetAllCities(response: AxiosResponse): Promise<CityModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CityModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CityModel[]>(null as any);
    }

    getCitiesByCountryAndState(countryIso2: string, state: string, cancelToken?: CancelToken): Promise<CityModel[]> {
        let url_ = this.baseUrl + "/api/countries/{countryIso2}/states/{state}/cities";
        if (countryIso2 === undefined || countryIso2 === null)
            throw new Error("The parameter 'countryIso2' must be defined.");
        url_ = url_.replace("{countryIso2}", encodeURIComponent("" + countryIso2));
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined.");
        url_ = url_.replace("{state}", encodeURIComponent("" + state));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCitiesByCountryAndState(_response);
        });
    }

    protected processGetCitiesByCountryAndState(response: AxiosResponse): Promise<CityModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CityModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CityModel[]>(null as any);
    }

    getCitiesFromPostalCode(countryIso2: string, postalCode: string, cancelToken?: CancelToken): Promise<CityModel[]> {
        let url_ = this.baseUrl + "/api/countries/{countryIso2}/postalCodes/{postalCode}/cities";
        if (countryIso2 === undefined || countryIso2 === null)
            throw new Error("The parameter 'countryIso2' must be defined.");
        url_ = url_.replace("{countryIso2}", encodeURIComponent("" + countryIso2));
        if (postalCode === undefined || postalCode === null)
            throw new Error("The parameter 'postalCode' must be defined.");
        url_ = url_.replace("{postalCode}", encodeURIComponent("" + postalCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCitiesFromPostalCode(_response);
        });
    }

    protected processGetCitiesFromPostalCode(response: AxiosResponse): Promise<CityModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CityModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CityModel[]>(null as any);
    }

    getZipCodeFromCityAndState(city: string, state: string, countryIso2: string, cancelToken?: CancelToken): Promise<ZipCodeViewModel[]> {
        let url_ = this.baseUrl + "/api/countries/{countryIso2}/states/{state}/cities/{city}";
        if (city === undefined || city === null)
            throw new Error("The parameter 'city' must be defined.");
        url_ = url_.replace("{city}", encodeURIComponent("" + city));
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined.");
        url_ = url_.replace("{state}", encodeURIComponent("" + state));
        if (countryIso2 === undefined || countryIso2 === null)
            throw new Error("The parameter 'countryIso2' must be defined.");
        url_ = url_.replace("{countryIso2}", encodeURIComponent("" + countryIso2));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetZipCodeFromCityAndState(_response);
        });
    }

    protected processGetZipCodeFromCityAndState(response: AxiosResponse): Promise<ZipCodeViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ZipCodeViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ZipCodeViewModel[]>(null as any);
    }

    getZipCodesFromCityAndCountry(city: string, countryIso2: string, cancelToken?: CancelToken): Promise<ZipCodeViewModel[]> {
        let url_ = this.baseUrl + "/api/countries/{countryIso2}/cities/{city}/postalCodes";
        if (city === undefined || city === null)
            throw new Error("The parameter 'city' must be defined.");
        url_ = url_.replace("{city}", encodeURIComponent("" + city));
        if (countryIso2 === undefined || countryIso2 === null)
            throw new Error("The parameter 'countryIso2' must be defined.");
        url_ = url_.replace("{countryIso2}", encodeURIComponent("" + countryIso2));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetZipCodesFromCityAndCountry(_response);
        });
    }

    protected processGetZipCodesFromCityAndCountry(response: AxiosResponse): Promise<ZipCodeViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ZipCodeViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ZipCodeViewModel[]>(null as any);
    }
}

export class CompleteEnrollmentClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    completeEnrollment( cancelToken?: CancelToken): Promise<IEnrollmentCompletedViewModel> {
        let url_ = this.baseUrl + "/api/complete-enrollment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteEnrollment(_response);
        });
    }

    protected processCompleteEnrollment(response: AxiosResponse): Promise<IEnrollmentCompletedViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IEnrollmentCompletedViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IEnrollmentCompletedViewModel>(null as any);
    }
}

export class AddressVerificationClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    verifyAddress(form: AddressEntryForm, cancelToken?: CancelToken): Promise<AddressVerificationResponse> {
        let url_ = this.baseUrl + "/api/address-verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyAddress(_response);
        });
    }

    protected processVerifyAddress(response: AxiosResponse): Promise<AddressVerificationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AddressVerificationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressVerificationResponse>(null as any);
    }
}

export class ViesVatVerificationClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    verifyTaxId(form: TaxIdEntryForm, cancelToken?: CancelToken): Promise<ViesVatVerificationResponse> {
        let url_ = this.baseUrl + "/api/taxid-verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyTaxId(_response);
        });
    }

    protected processVerifyTaxId(response: AxiosResponse): Promise<ViesVatVerificationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ViesVatVerificationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ViesVatVerificationResponse>(null as any);
    }
}

export class AccountsAPIRedirectLogClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    log(redirectLog: Enrollment2RedirectLogViewModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/redirect-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(redirectLog);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLog(_response);
        });
    }

    protected processLog(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TokenClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getDevAuthToken( cancelToken?: CancelToken): Promise<AuthenticationToken> {
        let url_ = this.baseUrl + "/api/token/dev-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDevAuthToken(_response);
        });
    }

    protected processGetDevAuthToken(response: AxiosResponse): Promise<AuthenticationToken> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AuthenticationToken>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationToken>(null as any);
    }

    reissue( cancelToken?: CancelToken): Promise<AuthenticationToken> {
        let url_ = this.baseUrl + "/api/token/reissue";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReissue(_response);
        });
    }

    protected processReissue(response: AxiosResponse): Promise<AuthenticationToken> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AuthenticationToken>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationToken>(null as any);
    }
}

export class EnrollmentAgreementsClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getExceliaAgreement(request: ExceliaErRequest | undefined, cancelToken?: CancelToken): Promise<ExceliaAgreementViewModel> {
        let url_ = this.baseUrl + "/api/generate-excelia-agreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExceliaAgreement(_response);
        });
    }

    protected processGetExceliaAgreement(response: AxiosResponse): Promise<ExceliaAgreementViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ExceliaAgreementViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExceliaAgreementViewModel>(null as any);
    }

    saveExceliaAgreement(form: SendToExceliaFormModel, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/save-excelia-agreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveExceliaAgreement(_response);
        });
    }

    protected processSaveExceliaAgreement(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class TranslationClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    lookupRomanTranslation(name: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/kana-look-up/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLookupRomanTranslation(_response);
        });
    }

    protected processLookupRomanTranslation(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SocialLinkClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    startCreatorModeEnrollment(form: StartCreatorModeForm, cancelToken?: CancelToken): Promise<EnrollmentStatusViewModel> {
        let url_ = this.baseUrl + "/api/social-links/creator-mode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartCreatorModeEnrollment(_response);
        });
    }

    protected processStartCreatorModeEnrollment(response: AxiosResponse): Promise<EnrollmentStatusViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EnrollmentStatusViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrollmentStatusViewModel>(null as any);
    }

    getSocialLinkConfig(countryIso: string | null | undefined, cancelToken?: CancelToken): Promise<SocialLinkConfigViewModel> {
        let url_ = this.baseUrl + "/api/social-links/config?";
        if (countryIso !== undefined && countryIso !== null)
            url_ += "countryIso=" + encodeURIComponent("" + countryIso) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSocialLinkConfig(_response);
        });
    }

    protected processGetSocialLinkConfig(response: AxiosResponse): Promise<SocialLinkConfigViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SocialLinkConfigViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SocialLinkConfigViewModel>(null as any);
    }

    validateSocialLinkNameIsUnique(name: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/social-links/validate-name/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateSocialLinkNameIsUnique(_response);
        });
    }

    protected processValidateSocialLinkNameIsUnique(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSocialLinks(searchText: string | null | undefined, includingArchiveLinks: boolean | undefined, cancelToken?: CancelToken): Promise<SocialLinkViewModel[]> {
        let url_ = this.baseUrl + "/api/social-links?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (includingArchiveLinks === null)
            throw new Error("The parameter 'includingArchiveLinks' cannot be null.");
        else if (includingArchiveLinks !== undefined)
            url_ += "includingArchiveLinks=" + encodeURIComponent("" + includingArchiveLinks) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSocialLinks(_response);
        });
    }

    protected processGetSocialLinks(response: AxiosResponse): Promise<SocialLinkViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SocialLinkViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SocialLinkViewModel[]>(null as any);
    }

    createSocialLink( cancelToken?: CancelToken): Promise<SocialLinkViewModel> {
        let url_ = this.baseUrl + "/api/social-links";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSocialLink(_response);
        });
    }

    protected processCreateSocialLink(response: AxiosResponse): Promise<SocialLinkViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SocialLinkViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SocialLinkViewModel>(null as any);
    }

    createSocialLinkEnrollment(linkId: string, cancelToken?: CancelToken): Promise<EnrollmentStatusViewModel> {
        let url_ = this.baseUrl + "/api/social-links/{linkId}/enrollment-status";
        if (linkId === undefined || linkId === null)
            throw new Error("The parameter 'linkId' must be defined.");
        url_ = url_.replace("{linkId}", encodeURIComponent("" + linkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSocialLinkEnrollment(_response);
        });
    }

    protected processCreateSocialLinkEnrollment(response: AxiosResponse): Promise<EnrollmentStatusViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EnrollmentStatusViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrollmentStatusViewModel>(null as any);
    }

    updateSocialLink(linkId: string, form: UpdateSocialLinkForm, cancelToken?: CancelToken): Promise<SocialLinkViewModel> {
        let url_ = this.baseUrl + "/api/social-links/{linkId}";
        if (linkId === undefined || linkId === null)
            throw new Error("The parameter 'linkId' must be defined.");
        url_ = url_.replace("{linkId}", encodeURIComponent("" + linkId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSocialLink(_response);
        });
    }

    protected processUpdateSocialLink(response: AxiosResponse): Promise<SocialLinkViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SocialLinkViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SocialLinkViewModel>(null as any);
    }

    deleteSocialLink(linkId: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/social-links/{linkId}";
        if (linkId === undefined || linkId === null)
            throw new Error("The parameter 'linkId' must be defined.");
        url_ = url_.replace("{linkId}", encodeURIComponent("" + linkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSocialLink(_response);
        });
    }

    protected processDeleteSocialLink(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    addSocialLinkShareStatus(linkId: string, status: ShareStatus, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/social-links/{linkId}/share-statuses/{status}";
        if (linkId === undefined || linkId === null)
            throw new Error("The parameter 'linkId' must be defined.");
        url_ = url_.replace("{linkId}", encodeURIComponent("" + linkId));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddSocialLinkShareStatus(_response);
        });
    }

    protected processAddSocialLinkShareStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSocialLinkItems(linkId: string, cancelToken?: CancelToken): Promise<SocialLinkItemsViewModel> {
        let url_ = this.baseUrl + "/api/social-links/{linkId}/items";
        if (linkId === undefined || linkId === null)
            throw new Error("The parameter 'linkId' must be defined.");
        url_ = url_.replace("{linkId}", encodeURIComponent("" + linkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSocialLinkItems(_response);
        });
    }

    protected processGetSocialLinkItems(response: AxiosResponse): Promise<SocialLinkItemsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SocialLinkItemsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SocialLinkItemsViewModel>(null as any);
    }

    getTemplateUsageSummary(linkId: string, status: SocialLinkEnrollmentStatus, cancelToken?: CancelToken): Promise<TemplateUsageSummaryViewModel> {
        let url_ = this.baseUrl + "/api/social-links/{linkId}/enrollment-details/{status}";
        if (linkId === undefined || linkId === null)
            throw new Error("The parameter 'linkId' must be defined.");
        url_ = url_.replace("{linkId}", encodeURIComponent("" + linkId));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplateUsageSummary(_response);
        });
    }

    protected processGetTemplateUsageSummary(response: AxiosResponse): Promise<TemplateUsageSummaryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TemplateUsageSummaryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateUsageSummaryViewModel>(null as any);
    }
}

export class SocialLinkRedirectClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    startSocialLinkEnrollment(templateId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/social-links/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartSocialLinkEnrollment(_response);
        });
    }

    protected processStartSocialLinkEnrollment(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class AvailableShippingMethodsClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getShippingMethods(address: AddressEntryForm, cancelToken?: CancelToken): Promise<ShippingMethodsViewModel> {
        let url_ = this.baseUrl + "/api/shipping-methods";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(address);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShippingMethods(_response);
        });
    }

    protected processGetShippingMethods(response: AxiosResponse): Promise<ShippingMethodsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShippingMethodsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShippingMethodsViewModel>(null as any);
    }

    getAusPostConfiguration( cancelToken?: CancelToken): Promise<AusPostConfigurationModel> {
        let url_ = this.baseUrl + "/api/aus-post-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAusPostConfiguration(_response);
        });
    }

    protected processGetAusPostConfiguration(response: AxiosResponse): Promise<AusPostConfigurationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AusPostConfigurationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AusPostConfigurationModel>(null as any);
    }
}

export class ShippingCountryChangeClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getViewModelFor(isoCode: string, cancelToken?: CancelToken): Promise<AddressEntryViewModel> {
        let url_ = this.baseUrl + "/api/address-entry/{isoCode}";
        if (isoCode === undefined || isoCode === null)
            throw new Error("The parameter 'isoCode' must be defined.");
        url_ = url_.replace("{isoCode}", encodeURIComponent("" + isoCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetViewModelFor(_response);
        });
    }

    protected processGetViewModelFor(response: AxiosResponse): Promise<AddressEntryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AddressEntryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressEntryViewModel>(null as any);
    }
}

export class EnrollmentTransferClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    addGuestAccountInfo(customerInformation: CustomerInformationFormModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/transfer/guest-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerInformation);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddGuestAccountInfo(_response);
        });
    }

    protected processAddGuestAccountInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ProductInfoClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getViewModel(culture: string, partNumber: string, cancelToken?: CancelToken): Promise<ProductInfoViewModel> {
        let url_ = this.baseUrl + "/api/product-info/{culture}/{partNumber}";
        if (culture === undefined || culture === null)
            throw new Error("The parameter 'culture' must be defined.");
        url_ = url_.replace("{culture}", encodeURIComponent("" + culture));
        if (partNumber === undefined || partNumber === null)
            throw new Error("The parameter 'partNumber' must be defined.");
        url_ = url_.replace("{partNumber}", encodeURIComponent("" + partNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetViewModel(_response);
        });
    }

    protected processGetViewModel(response: AxiosResponse): Promise<ProductInfoViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProductInfoViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductInfoViewModel>(null as any);
    }
}

export class MeoKitClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getViewModel(selectedKitId: number | null | undefined, cancelToken?: CancelToken): Promise<MeoCartItemViewModel[]> {
        let url_ = this.baseUrl + "/api/update-meo-cart?";
        if (selectedKitId !== undefined && selectedKitId !== null)
            url_ += "selectedKitId=" + encodeURIComponent("" + selectedKitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetViewModel(_response);
        });
    }

    protected processGetViewModel(response: AxiosResponse): Promise<MeoCartItemViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MeoCartItemViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeoCartItemViewModel[]>(null as any);
    }

    getEnrollmentOrderChoices( cancelToken?: CancelToken): Promise<EnrollmentOrderChoices> {
        let url_ = this.baseUrl + "/api/read-enrollment-order-choices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnrollmentOrderChoices(_response);
        });
    }

    protected processGetEnrollmentOrderChoices(response: AxiosResponse): Promise<EnrollmentOrderChoices> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EnrollmentOrderChoices>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrollmentOrderChoices>(null as any);
    }
}

export class CustomizationRedirectClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getViewModelForCurrentOrderSelections( cancelToken?: CancelToken): Promise<AddProductsRedirectViewModel> {
        let url_ = this.baseUrl + "/api/order-customization-redirect-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetViewModelForCurrentOrderSelections(_response);
        });
    }

    protected processGetViewModelForCurrentOrderSelections(response: AxiosResponse): Promise<AddProductsRedirectViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AddProductsRedirectViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddProductsRedirectViewModel>(null as any);
    }

    getViewModelForErOrderSelections( cancelToken?: CancelToken): Promise<AddProductsRedirectViewModel> {
        let url_ = this.baseUrl + "/api/er-customization-redirect-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetViewModelForErOrderSelections(_response);
        });
    }

    protected processGetViewModelForErOrderSelections(response: AxiosResponse): Promise<AddProductsRedirectViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AddProductsRedirectViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddProductsRedirectViewModel>(null as any);
    }

    getViewModelForErPskOrderSelections( cancelToken?: CancelToken): Promise<AddProductsRedirectViewModel> {
        let url_ = this.baseUrl + "/api/er-customization-with-psk-redirect-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetViewModelForErPskOrderSelections(_response);
        });
    }

    protected processGetViewModelForErPskOrderSelections(response: AxiosResponse): Promise<AddProductsRedirectViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AddProductsRedirectViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddProductsRedirectViewModel>(null as any);
    }
}

export class VoOrderReturnClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    submitEnrollmentOrder(form: OrderReturnFormModel, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/enrollment-order-return";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitEnrollmentOrder(_response);
        });
    }

    protected processSubmitEnrollmentOrder(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class MissingTranslationClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createMissingTranslation(lang: string, ns: string, translations: { [key: string]: string; } | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/missing-translations/{ns}/{lang}";
        if (lang === undefined || lang === null)
            throw new Error("The parameter 'lang' must be defined.");
        url_ = url_.replace("{lang}", encodeURIComponent("" + lang));
        if (ns === undefined || ns === null)
            throw new Error("The parameter 'ns' must be defined.");
        url_ = url_.replace("{ns}", encodeURIComponent("" + ns));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (translations !== null && translations !== undefined)
            content_.append("translations", JSON.stringify(translations));

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMissingTranslation(_response);
        });
    }

    protected processCreateMissingTranslation(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    addToContentful(lang: string, ns: string, values: { [key: string]: string; }, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/missing-translations/{ns}/{lang}";
        if (lang === undefined || lang === null)
            throw new Error("The parameter 'lang' must be defined.");
        url_ = url_.replace("{lang}", encodeURIComponent("" + lang));
        if (ns === undefined || ns === null)
            throw new Error("The parameter 'ns' must be defined.");
        url_ = url_.replace("{ns}", encodeURIComponent("" + ns));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(values);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToContentful(_response);
        });
    }

    protected processAddToContentful(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    moveTranslationContentful(form: CopyTranslationsToNamespaceForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/missing-translations/copy-translation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveTranslationContentful(_response);
        });
    }

    protected processMoveTranslationContentful(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getMissingTranslations( cancelToken?: CancelToken): Promise<MissingTranslationsViewModel> {
        let url_ = this.baseUrl + "/missing-translations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissingTranslations(_response);
        });
    }

    protected processGetMissingTranslations(response: AxiosResponse): Promise<MissingTranslationsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MissingTranslationsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MissingTranslationsViewModel>(null as any);
    }
}

export class GeolocationClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getViewModel(countryIsoCode: string, postalCode: string, cancelToken?: CancelToken): Promise<LatamAddressViewModel> {
        let url_ = this.baseUrl + "/api/latam-address/{countryIsoCode}/{postalCode}";
        if (countryIsoCode === undefined || countryIsoCode === null)
            throw new Error("The parameter 'countryIsoCode' must be defined.");
        url_ = url_.replace("{countryIsoCode}", encodeURIComponent("" + countryIsoCode));
        if (postalCode === undefined || postalCode === null)
            throw new Error("The parameter 'postalCode' must be defined.");
        url_ = url_.replace("{postalCode}", encodeURIComponent("" + postalCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetViewModel(_response);
        });
    }

    protected processGetViewModel(response: AxiosResponse): Promise<LatamAddressViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LatamAddressViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LatamAddressViewModel>(null as any);
    }

    getAddressInfoFromJapanesePostalCode(postalCode: string, cancelToken?: CancelToken): Promise<JapanAddressLookupViewModel> {
        let url_ = this.baseUrl + "/api/zip-to-address-japan/{postalCode}";
        if (postalCode === undefined || postalCode === null)
            throw new Error("The parameter 'postalCode' must be defined.");
        url_ = url_.replace("{postalCode}", encodeURIComponent("" + postalCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAddressInfoFromJapanesePostalCode(_response);
        });
    }

    protected processGetAddressInfoFromJapanesePostalCode(response: AxiosResponse): Promise<JapanAddressLookupViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<JapanAddressLookupViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JapanAddressLookupViewModel>(null as any);
    }
}

export class CmsFooterRepositoryClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCmsFooter(locale: string, cancelToken?: CancelToken): Promise<CmsFooterViewModel> {
        let url_ = this.baseUrl + "/api/cmsfooter/{locale}";
        if (locale === undefined || locale === null)
            throw new Error("The parameter 'locale' must be defined.");
        url_ = url_.replace("{locale}", encodeURIComponent("" + locale));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCmsFooter(_response);
        });
    }

    protected processGetCmsFooter(response: AxiosResponse): Promise<CmsFooterViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CmsFooterViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CmsFooterViewModel>(null as any);
    }
}

export class StepModulesClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getViewModels(stepId: number, module: number | null | undefined, cancelToken?: CancelToken): Promise<StepModulesViewModel> {
        let url_ = this.baseUrl + "/api/steps/{stepId}?";
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        if (module !== undefined && module !== null)
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetViewModels(_response);
        });
    }

    protected processGetViewModels(response: AxiosResponse): Promise<StepModulesViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<StepModulesViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StepModulesViewModel>(null as any);
    }

    saveModuleData(form: StepModulesFormModel, cancelToken?: CancelToken): Promise<EnrollmentModules[]> {
        let url_ = this.baseUrl + "/api/steps/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveModuleData(_response);
        });
    }

    protected processSaveModuleData(response: AxiosResponse): Promise<EnrollmentModules[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EnrollmentModules[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrollmentModules[]>(null as any);
    }
}

export class EnrollmentProcessClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getEnrollmentConfigViewModel(storeId: number, tag: string | null | undefined, cancelToken?: CancelToken): Promise<EnrollmentConfigViewModel> {
        let url_ = this.baseUrl + "/api/enrollment-process/store/{storeId}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (tag !== undefined && tag !== null)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnrollmentConfigViewModel(_response);
        });
    }

    protected processGetEnrollmentConfigViewModel(response: AxiosResponse): Promise<EnrollmentConfigViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EnrollmentConfigViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrollmentConfigViewModel>(null as any);
    }
}

export class SponsorEnrollerClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    validateSponsorAndEnroller(sponsorId: number | undefined, enrollerId: number | undefined, cancelToken?: CancelToken): Promise<UplineValidationStatus> {
        let url_ = this.baseUrl + "/api/sponsor-enroller-validation?";
        if (sponsorId === null)
            throw new Error("The parameter 'sponsorId' cannot be null.");
        else if (sponsorId !== undefined)
            url_ += "sponsorId=" + encodeURIComponent("" + sponsorId) + "&";
        if (enrollerId === null)
            throw new Error("The parameter 'enrollerId' cannot be null.");
        else if (enrollerId !== undefined)
            url_ += "enrollerId=" + encodeURIComponent("" + enrollerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateSponsorAndEnroller(_response);
        });
    }

    protected processValidateSponsorAndEnroller(response: AxiosResponse): Promise<UplineValidationStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UplineValidationStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UplineValidationStatus>(null as any);
    }

    validateGaiyoshomen(gaiyoshomenCode: string | null | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/gaiyoshomen-validation?";
        if (gaiyoshomenCode !== undefined && gaiyoshomenCode !== null)
            url_ += "gaiyoshomenCode=" + encodeURIComponent("" + gaiyoshomenCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateGaiyoshomen(_response);
        });
    }

    protected processValidateGaiyoshomen(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class EmailCheckClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    checkIfEmailIsTaken(form: EmailTakenFormModel, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/account/email-taken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckIfEmailIsTaken(_response);
        });
    }

    protected processCheckIfEmailIsTaken(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class TaxCheckClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    checkIfTaxIdTaken(formModel: TaxIdTakenFormModel, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/account/tax-id-taken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckIfTaxIdTaken(_response);
        });
    }

    protected processCheckIfTaxIdTaken(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    checkIfGovernmentIdTaken(formModel: GovernmentIdTakenFormModel, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/account/gov-id-taken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckIfGovernmentIdTaken(_response);
        });
    }

    protected processCheckIfGovernmentIdTaken(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class AccountCredentialClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    saveAccountCredentials(form: AccountCredentialForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/account/save-creds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAccountCredentials(_response);
        });
    }

    protected processSaveAccountCredentials(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    checkUserName(formModel: UserNameTakenFormModel, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/account/verify-username";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckUserName(_response);
        });
    }

    protected processCheckUserName(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteAccountCredentials( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/delete-user-credentials";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAccountCredentials(_response);
        });
    }

    protected processDeleteAccountCredentials(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EnrollmentStatusClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getStatus(form: EnrollmentStatusFormModel, cancelToken?: CancelToken): Promise<EnrollmentStatusViewModel> {
        let url_ = this.baseUrl + "/api/enrollment-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: AxiosResponse): Promise<EnrollmentStatusViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EnrollmentStatusViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrollmentStatusViewModel>(null as any);
    }

    updateLocale(locale: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/enrollment-status/locale/{locale}";
        if (locale === undefined || locale === null)
            throw new Error("The parameter 'locale' must be defined.");
        url_ = url_.replace("{locale}", encodeURIComponent("" + locale));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLocale(_response);
        });
    }

    protected processUpdateLocale(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class CancellationClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    cancelEnrollment(enrollmentId: string | null | undefined, country: string | null | undefined, toRoot: boolean | undefined, language: string | null | undefined, tag: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/cancel?";
        if (enrollmentId !== undefined && enrollmentId !== null)
            url_ += "enrollmentId=" + encodeURIComponent("" + enrollmentId) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (toRoot === null)
            throw new Error("The parameter 'toRoot' cannot be null.");
        else if (toRoot !== undefined)
            url_ += "toRoot=" + encodeURIComponent("" + toRoot) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (tag !== undefined && tag !== null)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelEnrollment(_response);
        });
    }

    protected processCancelEnrollment(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class CaptchaClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    validateToken(captchaForm: CaptchaForm, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/captcha/validate-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(captchaForm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateToken(_response);
        });
    }

    protected processValidateToken(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class CacheClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    clearCache( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/clear-cache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearCache(_response);
        });
    }

    protected processClearCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VirtualWalletClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAuthorizationToken(type: VirtualWalletType, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/virtual-wallet/auth-token/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthorizationToken(_response);
        });
    }

    protected processGetAuthorizationToken(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    savePaymentToken(token: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/virtual-wallet/payment-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSavePaymentToken(_response);
        });
    }

    protected processSavePaymentToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    savePaymentId(paymentId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/virtual-wallet/payment-id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paymentId);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSavePaymentId(_response);
        });
    }

    protected processSavePaymentId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addVirtualWallet(type: VirtualWalletType, identifier: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/virtual-wallet/payment-methods/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(identifier);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddVirtualWallet(_response);
        });
    }

    protected processAddVirtualWallet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PayPalClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getExpressCheckoutToken( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/paypal/express-checkout-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExpressCheckoutToken(_response);
        });
    }

    protected processGetExpressCheckoutToken(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    addPayPalPayment(formModel: AddPayPalFormModel, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/paypal/add-payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPayPalPayment(_response);
        });
    }

    protected processAddPayPalPayment(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CreditCardClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getTransactionStatus(transactionId: string, paymentMethodIdentity: string | null | undefined, cancelToken?: CancelToken): Promise<TransactionStatusViewModel> {
        let url_ = this.baseUrl + "/api/credit-card/transaction-status/{transactionId}?";
        if (transactionId === undefined || transactionId === null)
            throw new Error("The parameter 'transactionId' must be defined.");
        url_ = url_.replace("{transactionId}", encodeURIComponent("" + transactionId));
        if (paymentMethodIdentity !== undefined && paymentMethodIdentity !== null)
            url_ += "paymentMethodIdentity=" + encodeURIComponent("" + paymentMethodIdentity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTransactionStatus(_response);
        });
    }

    protected processGetTransactionStatus(response: AxiosResponse): Promise<TransactionStatusViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TransactionStatusViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransactionStatusViewModel>(null as any);
    }

    validateCreditCard(creditCartPreValidationForm: CreditCartPreValidationForm, cancelToken?: CancelToken): Promise<ValidateCreditCardAsyncResponseViewModel> {
        let url_ = this.baseUrl + "/api/credit-card/validate-async";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(creditCartPreValidationForm);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateCreditCard(_response);
        });
    }

    protected processValidateCreditCard(response: AxiosResponse): Promise<ValidateCreditCardAsyncResponseViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ValidateCreditCardAsyncResponseViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateCreditCardAsyncResponseViewModel>(null as any);
    }

    saveClientJsonValue(values: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/credit-card/client-json-value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(values);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveClientJsonValue(_response);
        });
    }

    protected processSaveClientJsonValue(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    associateCvvWithCreditCard(model: AssociateCvvWithCreditCardFormModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/credit-card/associate-cvv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssociateCvvWithCreditCard(_response);
        });
    }

    protected processAssociateCvvWithCreditCard(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resolveNextGateway(cardTypeName: string | null | undefined, cancelToken?: CancelToken): Promise<PaymentMethodProviderType | null> {
        let url_ = this.baseUrl + "/api/credit-card/resolve-next-gateway?";
        if (cardTypeName !== undefined && cardTypeName !== null)
            url_ += "cardTypeName=" + encodeURIComponent("" + cardTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveNextGateway(_response);
        });
    }

    protected processResolveNextGateway(response: AxiosResponse): Promise<PaymentMethodProviderType | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PaymentMethodProviderType | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentMethodProviderType | null>(null as any);
    }

    getEncryptionKey( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/credit-card/encryption-key";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEncryptionKey(_response);
        });
    }

    protected processGetEncryptionKey(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class InstallmentClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAvailableInstallments( cancelToken?: CancelToken): Promise<PaymentInstallment[]> {
        let url_ = this.baseUrl + "/api/installments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableInstallments(_response);
        });
    }

    protected processGetAvailableInstallments(response: AxiosResponse): Promise<PaymentInstallment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PaymentInstallment[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentInstallment[]>(null as any);
    }
}

export interface YlAssembliesVersionInfo {
    name?: string | undefined;
    fullVersion?: string | undefined;
    version?: string | undefined;
}

export interface PaymentStatusViewModel {
    paymentStatus: OrderPaymentStatus;
    token?: AuthenticationToken | undefined;
}

export enum OrderPaymentStatus {
    Failed = "Failed",
    Successful = "Successful",
    Pending = "Pending",
    Unknown = "Unknown",
}

export interface AuthenticationToken {
    userId: string;
    userName?: string | undefined;
    displayName?: string | undefined;
    memberId: number;
    email?: string | undefined;
    isDistributor: boolean;
    createdDate: string;
    expireDate: string;
    rememberMe: boolean;
    signature?: string | undefined;
    country?: string | undefined;
    culture?: string | undefined;
    claims?: string[] | undefined;
    customerType?: CustomerTypeModel | undefined;
    rank?: number | undefined;
    profileImageLink?: string | undefined;
    spoofingBy?: string | undefined;
    storeId: number;
    version?: number | undefined;
    stringForSigning?: string | undefined;
}

export interface CustomerTypeModel {
    id: number;
    name?: string | undefined;
}

export interface PromoVoucherEntryResponseViewModel {
    appliedPaymentsReview?: AppliedPaymentsReviewViewModel | undefined;
    available: boolean;
}

export interface AppliedPaymentsReviewViewModel {
    paymentDescription?: string | undefined;
    amount: number;
    voucherAmount?: number | undefined;
    selectedPaymentIdentifier?: string | undefined;
    paymentType?: EnrollmentPaymentType | undefined;
    paymentMethodProviderType?: PaymentMethodProviderType | undefined;
    creditCardData?: CreditCard | undefined;
    installment?: PaymentInstallment | undefined;
}

export enum EnrollmentPaymentType {
    CreditCard = "CreditCard",
    WireTransfer = "WireTransfer",
    PayPal = "PayPal",
    Sepa = "Sepa",
    Ideal = "Ideal",
    Payflex = "Payflex",
    VirtualWalletIdeal = "VirtualWalletIdeal",
    VirtualWalletPaypal = "VirtualWalletPaypal",
    Cod = "Cod",
    NuveiPaymentPage = "NuveiPaymentPage",
}

export enum PaymentMethodProviderType {
    None = "None",
    SprintAsia = "SprintAsia",
    Doku = "Doku",
    Braintree = "Braintree",
    Orbital = "Orbital",
    CyberSource = "CyberSource",
    Stripe = "Stripe",
    Ideal = "Ideal",
    Paypal = "Paypal",
    ApplePay = "ApplePay",
    Nuvei = "Nuvei",
    NuveiPaymentPage = "NuveiPaymentPage",
    GooglePay = "GooglePay",
    Bancontact = "Bancontact",
    SecurePay = "SecurePay",
    Mercadopago = "Mercadopago",
    Sony = "Sony",
}

export interface CreditCard {
    displayOnly: boolean;
    identity?: string | undefined;
    name?: string | undefined;
    obfuscatedNumber?: string | undefined;
    cardType?: CreditCardType | undefined;
    cvv?: string | undefined;
    expirationMonth: number;
    expirationYear: number;
    tokenExToken?: string | undefined;
}

export interface CreditCardType {
    id: number;
    value: CreditCardTypes;
    name?: string | undefined;
    regex?: string | undefined;
}

export enum CreditCardTypes {
    NotSet = "NotSet",
    Visa = "Visa",
    MasterCard = "MasterCard",
    AMEX = "AMEX",
    Discover = "Discover",
    DinersClub = "DinersClub",
    JCB = "JCB",
    UnionPay = "UnionPay",
    MIR = "MIR",
    Elo = "Elo",
    Hipercard = "Hipercard",
}

export interface PaymentInstallment {
    totalAmount: number;
    installmentAmount: number;
    installmentNumber: number;
    installmentKey?: string | undefined;
    installmentPlanId: number;
}

export interface EnrollmentConfigResponse {
    tags?: string[] | undefined;
}

export interface CountriesAndLanguagesViewModel {
    countries?: CountryModel[] | undefined;
}

export interface CountryModel {
    isoCode2?: string | undefined;
    isoCode3?: string | undefined;
    name?: string | undefined;
    defaultCultureId?: string | undefined;
    languages?: LanguageModel[] | undefined;
    currencies?: Currency[] | undefined;
}

export interface LanguageModel {
    localeCode?: string | undefined;
    localName?: string | undefined;
}

export interface Currency {
    code?: string | undefined;
    symbol?: string | undefined;
}

export interface CountriesViewModel {
    countries?: CountryViewModel[] | undefined;
}

export interface CountryViewModel {
    isoCode3?: string | undefined;
    isoCode2?: string | undefined;
    name?: string | undefined;
    states?: StateViewModel[] | undefined;
}

export interface StateViewModel {
    id: number;
    name?: string | undefined;
    abbreviation?: string | undefined;
}

export interface LanguageViewModel {
    localeCode?: string | undefined;
    label?: string | undefined;
    englishName?: string | undefined;
    localName?: string | undefined;
}

export interface SuburbModel {
    stateAbbreviation?: string | undefined;
    name?: string | undefined;
    sortOrder: number;
    postalCode?: string | undefined;
}

export interface CityModel {
    name?: string | undefined;
}

export interface ZipCodeViewModel {
    zipCode?: string | undefined;
}

export interface IEnrollmentCompletedViewModel {
    confirmationPageUrl?: string | undefined;
    token?: AuthenticationToken | undefined;
    analyticsEventData?: CompletionAnalyticsEventData | undefined;
    shouldPoll: boolean;
}

export interface CompletionAnalyticsEventData {
    sponsorId?: string | undefined;
    enrollerId?: string | undefined;
    memberType?: string | undefined;
    paymentType?: string | undefined;
    currencyCode?: string | undefined;
    orderId?: string | undefined;
    revenue?: string | undefined;
    tax?: string | undefined;
    shipping?: string | undefined;
    products?: ProductAnalyticsEventData[] | undefined;
    hasEr: boolean;
}

export interface ProductAnalyticsEventData {
    name?: string | undefined;
    id?: string | undefined;
    price?: string | undefined;
    quantity?: string | undefined;
}

export interface AddressVerificationResponse {
    isValid: boolean;
    originalAddress?: AddressEntryChoice | undefined;
    recommendations?: AddressEntryChoice[] | undefined;
}

export interface AddressEntryChoice {
    id: number;
    addressForm?: AddressEntryForm | undefined;
    address?: DisplayableAddressViewModel | undefined;
}

export interface AddressEntryForm {
    street1?: string | undefined;
    houseNumber?: string | undefined;
    interiorNumber?: string | undefined;
    neighborhood?: string | undefined;
    street2?: string | undefined;
    street3?: string | undefined;
    city?: string | undefined;
    stateProv?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    recipient?: string | undefined;
    isWillCall: boolean;
    isPickupPoint: boolean;
    isShiptoShop: boolean;
    isValidated?: boolean | undefined;
    locationId?: string | undefined;
}

export interface DisplayableAddressViewModel {
    lines?: string[] | undefined;
}

export interface ViesVatVerificationResponse {
    isValid: boolean;
    finishedValidation: boolean;
    name?: string | undefined;
    address?: string | undefined;
}

export interface TaxIdEntryForm {
    taxIdTypeId: number;
    taxId?: string | undefined;
    businessName?: string | undefined;
    businessLicenseId?: string | undefined;
    mexicoCurpId?: string | undefined;
    contextId?: string | undefined;
    isGSTRegistered: boolean;
    anzEnabled: boolean;
    businessAddress?: AddressEntryForm | undefined;
    noInputProvided: boolean;
}

export interface Enrollment2RedirectLogViewModel {
    url?: string | undefined;
    step?: string | undefined;
}

export interface ExceliaAgreementViewModel {
    document?: string | undefined;
    customerLegacyId: number;
}

export interface ExceliaErRequest {
    obfuscatedAccountNumber?: string | undefined;
    accountName?: string | undefined;
    expireDate?: string | undefined;
    commercialAgreementAccepted: boolean;
}

export interface SendToExceliaFormModel {
    creditCardInfo?: CreditCardFormModel | undefined;
    needsAcceptAndAuth: boolean;
    agreementKinds?: AgreementKind[] | undefined;
    customerLegacyId: number;
}

export interface CreditCardFormModel {
    identity: string;
    obfuscatedAccountNumber?: string | undefined;
    encryptedCardNumber?: string | undefined;
    encryptedCvv?: string | undefined;
    expMonth: number;
    expYear: number;
    nameOnCard?: string | undefined;
    validationPaymentTransactionId?: string | undefined;
    paymentMethodProviderType?: PaymentMethodProviderType | undefined;
    clientJsonValue?: string | undefined;
}

export enum AgreementKind {
    GST = "GST",
    Member = "Member",
    ER = "ER",
    DirectDeposit = "DirectDeposit",
    Boost = "Boost",
    Professional = "Professional",
    PoliciesAndProcedures = "PoliciesAndProcedures",
    ConsentLetter = "ConsentLetter",
    PreferredCustomer = "PreferredCustomer",
    PWS = "PWS",
    Excelia = "Excelia",
    ChinaBusinessBuilder = "ChinaBusinessBuilder",
    PrivacyPolicy = "PrivacyPolicy",
    TaxForms = "TaxForms",
    BrandPartner = "BrandPartner",
}

export interface EnrollmentStatusViewModel {
    enrollmentId: string;
    currentStep: number;
    locale?: string | undefined;
    storeId: number;
    tag?: string | undefined;
    countryIso?: string | undefined;
    isShielded: boolean;
    shieldAccessCode?: string | undefined;
    socialLinkHasExpired: boolean;
    countryIso3?: string | undefined;
    voucherCodeDetails?: VoucherDetailsInfo | undefined;
}

export interface VoucherDetailsInfo {
    code: number;
    createdCustomerId: string;
    isExpired: boolean;
    amount?: number | undefined;
    currency?: string | undefined;
}

export interface StartCreatorModeForm {
    linkName?: string | undefined;
    enrollerId: number;
    hideEnrollerLastName: boolean;
    sponsorId: number;
    hideSponsorLastName: boolean;
    locale?: string | undefined;
    countryIso?: string | undefined;
    creatorLocale?: string | undefined;
    countryIso3?: string | undefined;
    voucherCodeDetails?: VoucherDetailsInfo | undefined;
    categoryName?: string | undefined;
    enrollmentId?: string | undefined;
}

export interface SocialLinkConfigViewModel {
    availableCountries?: CountryModel[] | undefined;
    voucherDetails?: VoucherDetailsInfo[] | undefined;
    currentCurrencyCode?: string | undefined;
}

export interface SocialLinkViewModel {
    id: string;
    enrollmentId?: string | undefined;
    name?: string | undefined;
    category?: string | undefined;
    ownerId: number;
    createdDateUtc: string;
    shareStatuses?: { [key in keyof typeof ShareStatus]?: number; } | undefined;
    isArchived: boolean;
    enrollerId?: number | undefined;
    enrollerName?: string | undefined;
    hideEnrollerLastName: boolean;
    sponsorId?: number | undefined;
    sponsorName?: string | undefined;
    hideSponsorLastName: boolean;
    locale?: string | undefined;
    countryIso?: string | undefined;
    hasTemporaryUnavailableItems: boolean;
    hasUnavailableItems: boolean;
    socialLinkMetricsUsageCount?: SocialLinkMetricsUsageCount | undefined;
    isEnrolledAfterTemplateUsageMetrics: boolean;
    isEnrollingInEr?: boolean | undefined;
    countryName?: string | undefined;
}

export enum ShareStatus {
    Facebook = "Facebook",
    Twitter = "Twitter",
    Pinterest = "Pinterest",
    LinkedIn = "LinkedIn",
    Clipboard = "Clipboard",
    WhatsApp = "WhatsApp",
    Telegram = "Telegram",
}

export interface SocialLinkMetricsUsageCount {
    socialLinkEnrollmentFullyJoinedCount: number;
    socialLinkEnrollmentPartiallyJoinedCount: number;
    socialLinkEnrollmentAccessCount: number;
}

export interface UpdateSocialLinkForm {
    name?: string | undefined;
    category?: string | undefined;
    isArchived: boolean;
    sponsorId?: number | undefined;
    enrollerId?: number | undefined;
    locale?: string | undefined;
    voucherDetailsInfo?: VoucherDetailsInfo | undefined;
}

export interface SocialLinkItemsViewModel {
    starterKit?: EnrollmentOrderItemViewModel | undefined;
    additionalItems?: EnrollmentOrderItemViewModel[] | undefined;
    erKit?: EnrollmentOrderItemViewModel | undefined;
    erAdditionalItems?: EnrollmentOrderItemViewModel[] | undefined;
    currency?: CurrencyViewModel | undefined;
}

export interface EnrollmentOrderItemViewModel {
    partNumber?: string | undefined;
    legacyId: number;
    name?: string | undefined;
    pointValue: number;
    priceWithTax: number;
    imageUrl?: string | undefined;
    largeImageUrl?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    howToUse?: string | undefined;
    ingredients?: string | undefined;
    isPromotional: boolean;
    inStock: boolean;
    storeId: number;
    quantity: number;
    priceWithTaxTotal: number;
    itemStatusModel?: ItemStatusModel | undefined;
    status: ItemStatusAvailability;
}

export interface ItemStatusModel {
    id: number;
    name?: string | undefined;
}

export enum ItemStatusAvailability {
    Available = "Available",
    TemporaryUnavailable = "TemporaryUnavailable",
    Unavailable = "Unavailable",
}

export interface CurrencyViewModel {
    code?: string | undefined;
    symbol?: string | undefined;
}

export interface TemplateUsageSummaryViewModel {
    templateUsageSummary?: TemplateUsageSummary[] | undefined;
}

export interface TemplateUsageSummary {
    id: string;
    templateId: string;
    enrollmentId: string;
    legacyCustomerId: number;
    lastCompletedModule: EnrollmentModules;
    nextIncompleteModule: EnrollmentModules;
    enrollmentCompletedDate?: string | undefined;
    personalInfoSubmitedDate?: string | undefined;
    customerInfo?: Customer | undefined;
}

export enum EnrollmentModules {
    EnrollmentKitSelection = "EnrollmentKitSelection",
    ErKitSelection = "ErKitSelection",
    ClassicErKitSelection = "ClassicErKitSelection",
    AddProducts = "AddProducts",
    NameEntry = "NameEntry",
    AgeEntry = "AgeEntry",
    CoApplicantEntry = "CoApplicantEntry",
    AddressEntry = "AddressEntry",
    EmailEntry = "EmailEntry",
    PhoneEntry = "PhoneEntry",
    AccountCredentials = "AccountCredentials",
    PinEntry = "PinEntry",
    TaxIdEntry = "TaxIdEntry",
    SponsorEnroller = "SponsorEnroller",
    ShippingMethodSelection = "ShippingMethodSelection",
    ShippingAddressEntry = "ShippingAddressEntry",
    BillingEntry = "BillingEntry",
    OrderSummary = "OrderSummary",
    MembershipReview = "MembershipReview",
    PersonalInfoReview = "PersonalInfoReview",
    ShippingAndBillingReview = "ShippingAndBillingReview",
    OrderTotalReview = "OrderTotalReview",
    AppliedPaymentsReview = "AppliedPaymentsReview",
    PromoVoucherEntry = "PromoVoucherEntry",
    GenderEntry = "GenderEntry",
    AddressValidator = "AddressValidator",
    MemberAgreement = "MemberAgreement",
    GstAgreement = "GstAgreement",
    TaxFormsAgreement = "TaxFormsAgreement",
    Agreements = "Agreements",
    CompleteEnrollment = "CompleteEnrollment",
    CompleteNoPurchaseEnrollment = "CompleteNoPurchaseEnrollment",
    ShippingNotice = "ShippingNotice",
    ShareYoungLiving = "ShareYoungLiving",
    PreferencesEntry = "PreferencesEntry",
    ReferrerReview = "ReferrerReview",
    ContinueEnrollment = "ContinueEnrollment",
    DirectMarketingAgreementEntry = "DirectMarketingAgreementEntry",
    MeoKitSelection = "MeoKitSelection",
    SocialLinkEntry = "SocialLinkEntry",
    VisitMainsite = "VisitMainsite",
    CreateSocialLinkButton = "CreateSocialLinkButton",
    SocialLinkCreatorBanner = "SocialLinkCreatorBanner",
    SocialLinkErKitSelection = "SocialLinkErKitSelection",
    PrivacyPolicyAgreementEntry = "PrivacyPolicyAgreementEntry",
    ExceliaAgreementEntry = "ExceliaAgreementEntry",
    CaptchaEntry = "CaptchaEntry",
    ErSimplifiedUpsellEntry = "ErSimplifiedUpsellEntry",
    ConfirmMemberInfoEntry = "ConfirmMemberInfoEntry",
    StudentEntry = "StudentEntry",
    CustomerTypeEntry = "CustomerTypeEntry",
    ReviewTopBanner = "ReviewTopBanner",
    GovernmentEntry = "GovernmentEntry",
    DocumentsUploadEntry = "DocumentsUploadEntry",
}

export interface Customer {
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    firstNameKana?: string | undefined;
    lastNameKana?: string | undefined;
    firstNameRomaji?: string | undefined;
    lastNameRomaji?: string | undefined;
    email?: string | undefined;
    phones?: Phones | undefined;
}

export interface Phones {
    primaryPhone?: string | undefined;
    secondaryPhone?: string | undefined;
}

export enum SocialLinkEnrollmentStatus {
    InProgress = "InProgress",
    Completed = "Completed",
}

export interface ShippingMethodsViewModel {
    shippingMethods?: ShippingMethodViewModel[] | undefined;
    isInRestrictedArea: boolean;
    isAddressSet: boolean;
}

export interface ShippingMethodViewModel {
    id: number;
    name?: string | undefined;
    shortName?: string | undefined;
    willCallAddress?: AddressEntryForm | undefined;
    isWillCall: boolean;
    isAusPost: boolean;
    isPickupPoint: boolean;
    carrierId?: number | undefined;
    carrierName?: string | undefined;
    rate: number;
    estimatedDelivery?: string | undefined;
    deliveryTimes?: DeliveryTimeViewModel[] | undefined;
}

export interface DeliveryTimeViewModel {
    id: number;
    name?: string | undefined;
}

export interface AusPostConfigurationModel {
    apiKey?: string | undefined;
    apiSecret?: string | undefined;
    googleApiKey?: string | undefined;
    merchantId?: string | undefined;
    emailInputId?: string | undefined;
}

export interface AddressEntryViewModel {
    form?: AddressFormModel | undefined;
    data?: AddressEntryForm | undefined;
    fieldRegularExpression?: string | undefined;
    postalCodeValidation?: ZipCodeValidationViewModel | undefined;
    phoneValidation?: PhoneValidationViewModel | undefined;
    storeId: number;
    shouldValidateAddress: boolean;
    shouldConfirmAddress: boolean;
    inEditMode: boolean;
    isShippingRestricted: boolean;
    shippingRestrictedStates?: string[] | undefined;
}

export interface AddressFormModel {
    rows?: AddressRow[] | undefined;
    hideStreet3: boolean;
}

export interface AddressRow {
    formFields?: ComponentField[] | undefined;
}

export interface ComponentField {
    id?: string | undefined;
    fieldType: FieldType;
    labelKey?: string | undefined;
    redLabelKey?: string | undefined;
    name?: string | undefined;
    inputType: InputType;
    required: boolean;
    disabled: boolean;
    maxLength?: number | undefined;
    minLength?: number | undefined;
    size: number;
    formatRegexForReplace?: string | undefined;
}

export enum FieldType {
    Input = "Input",
    Select = "Select",
    Radio = "Radio",
    Check = "Check",
    TextArea = "TextArea",
}

export enum InputType {
    CheckBox = "CheckBox",
    Hidden = "Hidden",
    Password = "Password",
    Radio = "Radio",
    Text = "Text",
}

export interface ZipCodeValidationViewModel {
    allowedCharactersRegEx?: string | undefined;
    validRegEx?: string | undefined;
}

export interface PhoneValidationViewModel {
    phoneRegularExpression?: string | undefined;
    internationalMode: boolean;
}

export interface CustomerInformationFormModel {
    enrollmentId: string;
    legacyId: number;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    country?: string | undefined;
    language?: string | undefined;
    tag?: string | undefined;
    dateOfBirth?: string | undefined;
    gender: number;
    primaryPhone?: string | undefined;
    secondaryPhone?: string | undefined;
    storeId: number;
    username?: string | undefined;
    credentials?: UserCredentialHash | undefined;
    referrer?: ReferrerModel | undefined;
    address?: ReceivedAddressModel | undefined;
    receiveEmail: boolean;
    taxInformation?: ReceivedTaxInformation | undefined;
}

export interface UserCredentialHash {
    hash?: string | undefined;
    salt?: string | undefined;
    credentialOptions?: CredentialOptions | undefined;
}

export interface CredentialOptions {
    hashIterations: number;
    hashLength: number;
}

export interface ReferrerModel {
    information?: string | undefined;
    sponsorId?: number | undefined;
    enrollerId?: number | undefined;
    gaiyoshomenValidationCode?: string | undefined;
}

export interface ReceivedAddressModel {
    street1?: string | undefined;
    street2?: string | undefined;
    street3?: string | undefined;
    city?: string | undefined;
    stateProv?: string | undefined;
    postalCode?: string | undefined;
    countryIsoCode?: string | undefined;
    name?: string | undefined;
    addressVerificationStatus: AddressVerificationStatus;
    qasLatitude?: string | undefined;
    qasLongitude?: string | undefined;
}

export enum AddressVerificationStatus {
    Unverified = "Unverified",
    Overridden = "Overridden",
    Verified = "Verified",
}

export interface ReceivedTaxInformation {
    taxIdTypeId?: number | undefined;
    taxId?: string | undefined;
    curpId?: string | undefined;
    taxBusinessName?: string | undefined;
    taxBusinessLicenseId?: string | undefined;
    contextId?: string | undefined;
    isGSTRegistered: boolean;
    isOptOut: boolean;
}

export interface ProductInfoViewModel {
    name?: string | undefined;
    imageUrl?: string | undefined;
    largeImageUrl?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    howToUse?: string | undefined;
    ingredients?: string | undefined;
    partNumber?: string | undefined;
    weight?: number | undefined;
}

export interface MeoCartItemViewModel {
    name?: string | undefined;
    partNumber?: string | undefined;
    quantity: number;
    price: number;
    itemPV: number;
}

export interface EnrollmentOrderChoices {
    enrollmentKitItemId?: number | undefined;
    erKitItemId?: number | undefined;
    isEnrollingInEr?: boolean | undefined;
    erAgreementAccepted?: boolean | undefined;
    isErAgreementDismissed?: boolean | undefined;
    usePremiumStarterKitAsErOrder?: boolean | undefined;
    useFirsErOrderAsTemplate?: boolean | undefined;
    usePremiumStarterKitAsMeoOrder?: boolean | undefined;
    customErType?: CustomErType | undefined;
    customErItems?: LineItem[] | undefined;
    additionalOrderItems?: LineItem[] | undefined;
    voucherCodeDetails?: VoucherDetailsInfo | undefined;
    unavailableItems?: Item[] | undefined;
}

export enum CustomErType {
    Custom = "Custom",
    Psk = "Psk",
}

export interface LineItem {
    id: number;
    quantity: number;
    isPromotional: boolean;
    isStarterKit: boolean;
}

export interface Item {
    itemId: number;
    productId: number;
    isDiscountItem: boolean;
    createdDate: string;
    countryOfOrigin?: string | undefined;
    dutyCode?: string | undefined;
    isSalesItem: boolean;
    internalName?: string | undefined;
    itemWeight?: number | undefined;
    partNumber?: string | undefined;
    type?: string | undefined;
    isNfr: boolean;
    variant?: string | undefined;
    classTypes?: number[] | undefined;
    variantByLocale?: { [key: string]: string; } | undefined;
    warehouseInfos?: { [key: string]: ItemWarehouseInfo; } | undefined;
}

export interface ItemWarehouseInfo {
    warehouseId: number;
    itemId: number;
    isInventoryItem: boolean;
    itemStatus?: ItemStatusModel | undefined;
    components?: KitComponent[] | undefined;
    purchaseInfo?: ItemPurchaseInfo | undefined;
    isAvailable: boolean;
    isPromotional: boolean;
    isNfr: boolean;
    isStarterKit: boolean;
    isErKit: boolean;
    isAKit: boolean;
}

export interface KitComponent {
    itemId: number;
    quantity: number;
}

export interface ItemPurchaseInfo {
    flags?: ItemFlags | undefined;
    availability?: ItemAvailability | undefined;
    pricesByPriceType?: { [key: string]: ItemPrices; } | undefined;
    quantityLimits?: ItemQuantityLimit[] | undefined;
    isActive: boolean;
    isNfr: boolean;
}

export interface ItemFlags {
    chocolate: boolean;
    erKit: boolean;
    extremelyDangerous: boolean;
    flammable: boolean;
    hazardous: boolean;
    promo: boolean;
    pws: boolean;
    starterKit: boolean;
    cbdOil: boolean;
    nySignatureRequired: boolean;
    rcExclVat: boolean;
}

export interface ItemAvailability {
    availCcdAutoship: boolean;
    availCcdEnrollment: boolean;
    availCcdErpoint: boolean;
    availCcdEvent: boolean;
    availCcdNormal: boolean;
    availKiosk: boolean;
    availTransfer: boolean;
    availWebAutoship: boolean;
    availWebEnrollment: boolean;
    availWebErpoint: boolean;
    availWebNormal: boolean;
    availWebPws: boolean;
    availTo3rdParty: boolean;
}

export interface ItemPrices {
    customerTypeId: number;
    currencyCode?: string | undefined;
    retailPrice: number;
    salesTaxPrice: number;
    pointValue: number;
    pointCost: number;
    priceTypeId: number;
    priceTypeName?: string | undefined;
    isEmployeePrice: boolean;
}

export interface ItemQuantityLimit {
    endDate?: string | undefined;
    isActive: boolean;
    startDate?: string | undefined;
    limitAmount: number;
    quantityLimitType: QuantityLimitType;
    isErOnly: boolean;
    limitCriteria?: ItemLimitCriteria[] | undefined;
    id: string;
}

export enum QuantityLimitType {
    None = "None",
    LimitByOrder = "LimitByOrder",
    LimitByCustomer = "LimitByCustomer",
    LimitByCustomerLifetime = "LimitByCustomerLifetime",
    LimitPerMonth = "LimitPerMonth",
    LimitByCriteria = "LimitByCriteria",
}

export interface ItemLimitCriteria {
    criteriaAmount: number;
    productId: number;
    itemId: number;
}

export interface AddProductsRedirectViewModel {
    redirectUrl?: string | undefined;
}

export interface OrderReturnFormModel {
    enrollmentId: string;
    items?: OrderReturnItem[] | undefined;
    isCustomEr: boolean;
}

export interface OrderReturnItem {
    itemId: number;
    quantity: number;
    isPromotional: boolean;
    isStarterKit: boolean;
}

export interface CopyTranslationsToNamespaceForm {
    toNamespace?: string | undefined;
    translations?: CopyTranslationForm[] | undefined;
}

export interface CopyTranslationForm {
    fromNamespace?: string | undefined;
    fromLabel?: string | undefined;
    toLabel?: string | undefined;
}

export interface MissingTranslationsViewModel {
    languages?: MissingLanguageTranslations[] | undefined;
}

export interface MissingLanguageTranslations {
    language?: string | undefined;
    translations?: MissingTranslation[] | undefined;
}

export interface MissingTranslation {
    label?: string | undefined;
    value?: string | undefined;
    namespace?: string | undefined;
    language?: string | undefined;
}

export interface LatamAddressViewModel {
    state?: string | undefined;
    city?: string | undefined;
    municipality?: string | undefined;
    street?: string | undefined;
    neighborhood?: string | undefined;
    localityCode?: string | undefined;
}

export interface JapanAddressLookupViewModel {
    found: boolean;
    prefecture?: string | undefined;
    city?: string | undefined;
    street1?: string | undefined;
}

export interface CmsFooterViewModel {
    topLinks?: FooterLink[] | undefined;
    mainLinks?: FooterLink[] | undefined;
    partnerLinks?: FooterLink[] | undefined;
    socialLinks?: FooterLink[] | undefined;
    bottomLinks?: FooterLink[] | undefined;
    contactInfo?: FooterContactInfo | undefined;
    copyright?: string | undefined;
}

export interface FooterLink {
    text?: string | undefined;
    url?: string | undefined;
    title?: string | undefined;
    imageUrl?: string | undefined;
    icon?: string | undefined;
}

export interface FooterContactInfo {
    title?: string | undefined;
    address?: string | undefined;
    contactOptions?: FooterLink[] | undefined;
}

export interface StepModulesViewModel {
    enrollmentKitSelection?: EnrollmentKitSelectionViewModel | undefined;
    erKitSelection?: ErKitSelectionViewModel | undefined;
    socialLinkErKitSelection?: ErKitSelectionViewModel | undefined;
    classicErKitSelection?: ErKitSelectionViewModel | undefined;
    meoKitSelection?: MeoCartItemSummaryViewModel | undefined;
    nameEntry?: NameEntryViewModel | undefined;
    ageEntry?: AgeEntryViewModel | undefined;
    studentEntry?: StudentEntryViewModel | undefined;
    governmentEntry?: GovernmentEntryViewModel | undefined;
    documentsUploadEntry?: DocumentsUploadEntryViewModel | undefined;
    customerTypeEntry?: CustomerTypeEntryViewModel | undefined;
    coApplicantEntry?: CoApplicantEntryViewModel | undefined;
    addressEntry?: AddressEntryViewModel | undefined;
    emailEntry?: EmailEntryViewModel | undefined;
    phoneEntry?: PhoneEntryViewModel | undefined;
    accountCredentialsEntry?: AccountCredentialsEntryViewModel | undefined;
    pinEntry?: PinEntryViewModel | undefined;
    taxIdEntry?: TaxIdEntryViewModel | undefined;
    sponsorEnrollerEntry?: SponsorEnrollerEntryViewModel | undefined;
    memberAgreementEntry?: MemberAgreementViewModel | undefined;
    gstAgreementEntry?: GstAgreementViewModel | undefined;
    shippingMethodSelection?: ShippingMethodSelectionViewModel | undefined;
    shippingAddressEntry?: ShippingAddressEntryViewModel | undefined;
    billingEntry?: BillingEntryViewModel | undefined;
    orderSummary?: OrderSummaryViewModel | undefined;
    membershipReview?: MembershipReviewViewModel | undefined;
    referrerReview?: ReferrerReviewViewModel | undefined;
    personalInfoReview?: PersonalInfoReviewViewModel | undefined;
    shippingAndBillingReview?: ShippingAndBillingReviewViewModel | undefined;
    orderTotalReview?: OrderTotalReviewViewModel | undefined;
    orderReturnPolicyReview?: OrderReturnPolicyViewModel | undefined;
    memberAgreementOrderReview?: MemberAgreementOrderReview | undefined;
    appliedPaymentsReview?: AppliedPaymentsReviewViewModel | undefined;
    promoVoucherEntry?: PromoVoucherEntryViewModel | undefined;
    genderEntry?: GenderEntryViewModel | undefined;
    confirmMemberInfoEntry?: ConfirmMemberInfoEntryViewModel | undefined;
    taxFormsAgreementEntry?: TaxFormsAgreementViewModel | undefined;
    completeEnrollmentProcessor?: CompleteEnrollmentViewModel | undefined;
    shareYoungLivingEntry?: ShareYoungLivingViewModel | undefined;
    preferencesEntry?: PreferencesEntryViewModel | undefined;
    directMarketingAgreementEntry?: DirectMarketingAgreementViewModel | undefined;
    privacyPolicyAgreementEntry?: PrivacyPolicyAgreementViewModel | undefined;
    exceliaAgreementEntry?: ExceliaAgreementViewModel | undefined;
    captchaEntry?: CaptchaViewModel | undefined;
    socialLinkEntry?: SocialLinkEntryViewModel | undefined;
    socialLinkCreatorEntry?: SocialLinkCreatorEntryViewModel | undefined;
    threeDSecureEntry?: ThreeDSecureEntryViewModel | undefined;
    completedModules?: EnrollmentModules[] | undefined;
    activeModuleGroup?: number | undefined;
    showWelcome: boolean;
    showShippingMessage: boolean;
    showCookieWarning: boolean;
    isGlobalNfr: boolean;
    showWarning: boolean;
    showReturnPolicy: boolean;
    earlyEnrollment: boolean;
    redirectToStepOne: boolean;
    allowCompletionWithoutOrder: boolean;
    showDataProtectionSection: boolean;
    orderReviewAgreementEnabled: boolean;
    orderReturnPolicyEnabled: boolean;
    weightValueForPSKEnabled: boolean;
    isShipToShopEnabled: boolean;
    shipToShopUrl?: string | undefined;
    useNewSLMode: boolean;
    isRetailCustomerbenefitsToollTipEnabled: boolean;
    isFlagPriceEnabled: boolean;
    phaseTag?: string | undefined;
    governmentIdFormat?: string | undefined;
}

export interface EnrollmentKitSelectionViewModel {
    currentTab: number;
    displayStyle: StarterKitDisplayStyle;
    tabs?: StarterKitTab[] | undefined;
    baseKit?: StarterKitBaseViewModel | undefined;
    selectedKit?: number | undefined;
    additionalOrderItems?: number[] | undefined;
    requireStarterKit: boolean;
    minimumErPv: number;
    isMeoEnabled: boolean;
    minimumEnrollmentOrderPv: number;
    additionalOrderItemsTotalPv: number;
    allowToBypassMeoRequirementWithPSK: boolean;
}

export enum StarterKitDisplayStyle {
    Tabbed = "Tabbed",
    Standard = "Standard",
}

export interface StarterKitTab {
    id: number;
    tabType: StarterKitTabType;
    displayStyle: StarterKitTabStyle;
    productKits?: ProductKit[] | undefined;
    show: boolean;
}

export enum StarterKitTabType {
    Popular = "Popular",
    Premium = "Premium",
    Specialty = "Specialty",
    Basic = "Basic",
    Other = "Other",
    Unknown = "Unknown",
}

export enum StarterKitTabStyle {
    Classic = "Classic",
    Dynamic = "Dynamic",
    Grid = "Grid",
    Basic = "Basic",
}

export interface ProductKit {
    partNumber?: string | undefined;
    description?: string | undefined;
    largeImageUrl?: string | undefined;
    smallImageUrl?: string | undefined;
    title?: string | undefined;
    listItems?: string[] | undefined;
    details?: string[] | undefined;
    itemId: number;
    price: number;
    pointValue: number;
    upgradeComponent?: UpgradeComponentInfo | undefined;
    isAutoShipAvailable?: boolean | undefined;
}

export interface UpgradeComponentInfo {
    partNumber?: string | undefined;
    title?: string | undefined;
    largeImageUrl?: string | undefined;
    smallImageUrl?: string | undefined;
}

export interface StarterKitBaseViewModel {
    name?: string | undefined;
    image?: string | undefined;
    imageLarge?: string | undefined;
    price: number;
}

export interface ErKitSelectionViewModel {
    enrollEssentialRewards?: boolean | undefined;
    usePremiumKitAsErOrder?: boolean | undefined;
    useFirsErOrderAsTemplate?: boolean | undefined;
    selectedKit?: number | undefined;
    erKits?: ProductKit[] | undefined;
    customErType?: CustomErType | undefined;
    canCustomizeErKit: boolean;
    canUsePskToAutoEnrollInEr: boolean;
    canCustomizeErWithPsk: boolean;
    erUpsellEnabled: boolean;
    useErSingleQuestion: boolean;
    isEnableForErAgreement: boolean;
    erAgreementAccepted?: boolean | undefined;
    isErAgreementDismissed?: boolean | undefined;
    scrollText?: string | undefined;
    agreementId?: string | undefined;
    isErAgreementDismissible?: boolean | undefined;
    text?: string | undefined;
}

export interface MeoCartItemSummaryViewModel {
    meoCartItems?: MeoCartItemViewModel[] | undefined;
}

export interface NameEntryViewModel {
    form?: ModuleFormViewModel | undefined;
    data?: NameEntryForm | undefined;
    useTranslation: boolean;
}

export interface ModuleFormViewModel {
    formFields?: ComponentField[] | undefined;
}

export interface NameEntryForm {
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    lastNameKana?: string | undefined;
    firstNameKana?: string | undefined;
    lastNameRomaji?: string | undefined;
    firstNameRomaji?: string | undefined;
}

export interface AgeEntryViewModel {
    birthYear?: number | undefined;
    birthMonth?: number | undefined;
    birthDay?: number | undefined;
    confirmUserAtLeast18: boolean;
    requiredMinimumAge?: number | undefined;
    isRequired: boolean;
    isAgeCheckBoxSelected?: boolean | undefined;
}

export interface StudentEntryViewModel {
    isStudent?: boolean | undefined;
}

export interface GovernmentEntryViewModel {
    governmentId?: string | undefined;
}

export interface DocumentsUploadEntryViewModel {
    selectedFiles?: DocumentInfoModel[] | undefined;
    uploadedFiles?: DocumentInfoModel[] | undefined;
}

export interface DocumentInfoModel {
    name?: string | undefined;
    originalName?: string | undefined;
}

export interface CustomerTypeEntryViewModel {
    availableChoices?: EnrollmentCustomerType[] | undefined;
    currentType: EnrollmentCustomerType;
    isSwitched: boolean;
}

export enum EnrollmentCustomerType {
    PreferredCustomer = "PreferredCustomer",
    Distributor = "Distributor",
}

export interface CoApplicantEntryViewModel {
    form?: ModuleFormViewModel | undefined;
    data?: CoApplicantEntryForm | undefined;
}

export interface CoApplicantEntryForm {
    hasCoApplicant: boolean;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
}

export interface EmailEntryViewModel {
    email?: string | undefined;
    emailRegularExpression?: string | undefined;
}

export interface PhoneEntryViewModel {
    phoneRegularExpression?: string | undefined;
    form?: ModuleFormViewModel | undefined;
    data?: PhoneEntryForm | undefined;
    config?: PhoneEntryConfigViewModel | undefined;
    internationalMode: boolean;
}

export interface PhoneEntryForm {
    primaryPhone?: string | undefined;
    secondaryPhone?: string | undefined;
}

export interface PhoneEntryConfigViewModel {
    minLength: number;
    maxLength: number;
    phonePrefix?: string | undefined;
}

export interface AccountCredentialsEntryViewModel {
    userName?: string | undefined;
    existingAccount: boolean;
    userNameRegularExpression?: string | undefined;
    passwordRegularExpression?: string | undefined;
    reservedUserName?: string | undefined;
    isUsernameRequired: boolean;
}

export interface PinEntryViewModel {
    pinRegularExpression?: string | undefined;
    existingAccount: boolean;
}

export interface TaxIdEntryViewModel {
    taxIdContexts?: TaxIdContextViewModel[] | undefined;
    selectedContext?: string | undefined;
    shouldRequireUserInput: boolean;
    enteredTaxId?: string | undefined;
    businessName?: string | undefined;
    isGSTRegistered?: boolean | undefined;
    selectedTaxIdTypeId?: number | undefined;
    hasMultipleEntries: boolean;
    defaultToIndividual: boolean;
}

export interface TaxIdContextViewModel {
    id?: string | undefined;
    renderer: TaxIdContextRenderer;
    context: TaxIdTypeContext;
    entries?: TaxIdEntryOption[] | undefined;
    selectedEntryId: number;
}

export enum TaxIdContextRenderer {
    IndividualOptOut = "IndividualOptOut",
    IndividualStandard = "IndividualStandard",
    IndividualMexico = "IndividualMexico",
    IndividualMultiple = "IndividualMultiple",
    BusinessStandard = "BusinessStandard",
    BusinessMexico = "BusinessMexico",
    BusinessMultiple = "BusinessMultiple",
    BusinessEU = "BusinessEU",
    BusinessAustraliaNewZealand = "BusinessAustraliaNewZealand",
    Unknown = "Unknown",
}

export enum TaxIdTypeContext {
    Individual = "Individual",
    Business = "Business",
    Unknown = "Unknown",
}

export interface TaxIdEntryOption {
    taxIdTypeId: number;
    individual?: IndividualEntryViewModel | undefined;
    business?: BusinessEntryViewModel | undefined;
    mexicoCurp?: MexicoCurpViewModel | undefined;
}

export interface IndividualEntryViewModel {
    regularExpression?: string | undefined;
    isRequired: boolean;
    isUniqueRequired: boolean;
    taxId?: string | undefined;
    taxIdTypeId: number;
    name?: string | undefined;
    mask?: string | undefined;
    canCollect: boolean;
    countryIsoCode?: string | undefined;
}

export interface BusinessEntryViewModel {
    businessName?: string | undefined;
    taxId?: string | undefined;
    taxIdTypeId: number;
    businessLicense?: string | undefined;
    isRequired: boolean;
    isUniqueRequired: boolean;
    showBusinessName: boolean;
    requireBusinessName: boolean;
    showBusinessLicenseId: boolean;
    requireBusinessLicense: boolean;
    name?: string | undefined;
    mask?: string | undefined;
    regularExpression?: string | undefined;
    canCollect: boolean;
    isGSTRegistered: boolean;
    enableViesVerification: boolean;
    countryIsoCode?: string | undefined;
}

export interface MexicoCurpViewModel {
    individual?: IndividualEntryViewModel | undefined;
    curpId?: string | undefined;
    curpIdRegExp?: string | undefined;
    isRequired: boolean;
}

export interface SponsorEnrollerEntryViewModel {
    enrollerName?: string | undefined;
    enrollerFirstName?: string | undefined;
    enrollerLastName?: string | undefined;
    hideEnrollerLastName: boolean;
    sponsorName?: string | undefined;
    sponsorFirstName?: string | undefined;
    sponsorLastName?: string | undefined;
    hideSponsorLastName: boolean;
    sponsorId?: number | undefined;
    enrollerId?: number | undefined;
    wasReferred?: boolean | undefined;
    sponsorEnrollerRequired: boolean;
    consentedToPlacementProgram: boolean;
    requirePlacementProgramConsent: boolean;
    gaiyoshomenCode?: string | undefined;
    includeGaiyoshomen: boolean;
    excludeSponsor: boolean;
}

export interface MemberAgreementViewModel {
    text?: string | undefined;
    scrollText?: string | undefined;
    previouslyAcceptedThisAgreement: boolean;
    documents?: EnrollmentAgreementDocumentResponse[] | undefined;
}

export interface EnrollmentAgreementDocumentResponse {
    url?: string | undefined;
    description?: string | undefined;
}

export interface GstAgreementViewModel {
    text?: string | undefined;
    agreementAccepted: boolean;
}

export interface ShippingMethodSelectionViewModel {
    isInRestrictedArea: boolean;
    selectedShippingMethod?: number | undefined;
    selectedDeliveryTimeId?: number | undefined;
    hasDangerousGoods: boolean;
    hasCbdGoods: boolean;
    shippingMethods?: ShippingMethodViewModel[] | undefined;
    itemsRestrictedByLocation?: ItemRestrictedByLocationViewModel[] | undefined;
    noShippingItems: boolean;
    noShippingMethods: boolean;
    showDgWarning: boolean;
}

export interface ItemRestrictedByLocationViewModel {
    id: number;
    name?: string | undefined;
}

export interface ShippingAddressEntryViewModel {
    sameAsPrimaryAddress: boolean;
    form?: AddressFormModel | undefined;
    fieldRegularExpression?: string | undefined;
    postalCodeValidation?: ZipCodeValidationViewModel | undefined;
    phoneValidation?: PhoneValidationViewModel | undefined;
    storeId: number;
    shippingAddress?: AddressEntryForm | undefined;
    primaryAddress?: AddressEntryForm | undefined;
    willCallAddress?: AddressEntryForm | undefined;
    pickupPointAddress?: AddressEntryForm | undefined;
    ausPostAddress?: AddressEntryForm | undefined;
    shipToShopAddress?: AddressEntryForm | undefined;
    shouldValidateAddress: boolean;
    askIfSameAsPrimaryAddress: boolean;
    triggerCountryChangeAlert: boolean;
    isShippingCountryRestricted: boolean;
    shippingRestrictedStates?: string[] | undefined;
}

export interface BillingEntryViewModel {
    selectedPaymentType?: EnrollmentPaymentType | undefined;
    creditCardData?: CreditCard | undefined;
    creditCardConfig?: CreditCardConfigViewModel | undefined;
    sepaData?: Sepa | undefined;
    wireTransferData?: WireTransferFormModel | undefined;
    userEmail?: string | undefined;
    userPhoneNumber?: string | undefined;
    userShippingAddress?: AddressEntryForm | undefined;
    billingAddressEntry?: BillingAddressEntryViewModel | undefined;
    availablePaymentMethods?: EnrollmentPaymentType[] | undefined;
    payPalEnvironment?: string | undefined;
    shouldCollectBillingAddress: boolean;
    installmentEntry?: InstallmentEntryViewModel | undefined;
}

export interface CreditCardConfigViewModel {
    showRefundWarning: boolean;
    requireCvv: boolean;
    cardTypes?: CreditCardType[] | undefined;
}

export interface Sepa {
    displayOnly: boolean;
    firstNameOnAccount?: string | undefined;
    lastNameOnAccount?: string | undefined;
    iban?: string | undefined;
    agreementAccepted: boolean;
}

export interface WireTransferFormModel {
    bankOption?: string | undefined;
}

export interface BillingAddressEntryViewModel {
    sameAsShippingAddress: boolean;
    form?: AddressFormModel | undefined;
    fieldRegularExpression?: string | undefined;
    postalCodeValidation?: ZipCodeValidationViewModel | undefined;
    storeId: number;
    billingAddress?: AddressEntryForm | undefined;
}

export interface InstallmentEntryViewModel {
    enabledPaymentTypes?: EnrollmentPaymentType[] | undefined;
    selectedInstallment?: number | undefined;
    availableInstallments?: PaymentInstallment[] | undefined;
}

export interface OrderSummaryViewModel {
    externalReferenceId?: string | undefined;
    essentialRewardItems?: OrderItemViewModel[] | undefined;
    enrollmentItems?: OrderItemViewModel[] | undefined;
    editStepNumber: number;
    hideEditStepButton: boolean;
    isMeoEnabled: boolean;
    usePremiumStarterKitAsErOrder?: boolean | undefined;
    orderWeight?: number | undefined;
}

export interface OrderItemViewModel {
    name?: string | undefined;
    imageUrl?: string | undefined;
    partNumber?: string | undefined;
    quantity: number;
    price: number;
    totalPrice: number;
    isPromotional: boolean;
    weight?: number | undefined;
    totalWeight?: number | undefined;
}

export interface MembershipReviewViewModel {
    customerType: CustomerType;
    sponsorId?: number | undefined;
    sponsorName?: string | undefined;
    enrollerId?: number | undefined;
    enrollerName?: string | undefined;
    hasReferrer: boolean;
}

export enum CustomerType {
    Unknown = "Unknown",
    WholeSale = "WholeSale",
    Distributor = "Distributor",
    Retail = "Retail",
    Professional = "Professional",
    Employee = "Employee",
}

export interface ReferrerReviewViewModel {
    sponsorId?: number | undefined;
    sponsorName?: string | undefined;
    sponsorFirstName?: string | undefined;
    sponsorLastName?: string | undefined;
    hideSponsorLastName: boolean;
    enrollerId?: number | undefined;
    enrollerName?: string | undefined;
    enrollerFirstName?: string | undefined;
    enrollerLastName?: string | undefined;
    hideEnrollerLastName: boolean;
    editStepNumber: number;
    hasReferrer: boolean;
    gaiyoshomenCode?: string | undefined;
}

export interface PersonalInfoReviewViewModel {
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    primaryAddress?: DisplayableAddressViewModel | undefined;
    email?: string | undefined;
    primaryPhone?: string | undefined;
    taxId?: string | undefined;
    editStepNumber: number;
}

export interface ShippingAndBillingReviewViewModel {
    shippingMethod?: string | undefined;
    shippingAddress?: DisplayableAddressViewModel | undefined;
    userShippingAddress?: AddressEntryForm | undefined;
    billingAddress?: AddressEntryForm | undefined;
    editStepNumber: number;
}

export interface OrderTotalReviewViewModel {
    subtotal: number;
    shipping: number;
    taxTotal: number;
    total: number;
    pvTotal: number;
    taxableAmount: number;
    salesTax: number;
    shippingTax: number;
}

export interface OrderReturnPolicyViewModel {
    acceptReview: boolean;
}

export interface MemberAgreementOrderReview {
    agreementdirectMarketing: boolean;
    termsAndConditionsAgreement: boolean;
    confirmAccuracyAgreement: boolean;
}

export interface PromoVoucherEntryViewModel {
    voucherCode?: number | undefined;
}

export interface GenderEntryViewModel {
    selectedGender?: Gender | undefined;
    required: boolean;
    showOnlyBaseGenders: boolean;
}

export enum Gender {
    Unspecified = "Unspecified",
    Male = "Male",
    Female = "Female",
    NonBinary = "NonBinary",
}

export interface ConfirmMemberInfoEntryViewModel {
    confirmed?: boolean | undefined;
}

export interface TaxFormsAgreementViewModel {
    text?: string | undefined;
    documents?: EnrollmentAgreementDocumentResponse[] | undefined;
}

export interface CompleteEnrollmentViewModel {
    reviewPageStepNumber: number;
    editPaymentStepNumber: number;
    requireCvvForPurchase: boolean;
}

export interface ShareYoungLivingViewModel {
    modules?: EnrollmentModules[] | undefined;
    isSharingYoungLiving?: boolean | undefined;
}

export interface PreferencesEntryViewModel {
    receiveEmail: boolean;
}

export interface DirectMarketingAgreementViewModel {
    agreementAccepted: boolean;
}

export interface PrivacyPolicyAgreementViewModel {
    text?: string | undefined;
    documents?: EnrollmentAgreementDocumentResponse[] | undefined;
}

export interface CaptchaViewModel {
    publicKey?: string | undefined;
}

export interface SocialLinkEntryViewModel {
    referrerReview?: ReferrerReviewViewModel | undefined;
    enrollmentOrderInfo?: EnrollmentOrderInfoViewModel | undefined;
    isMeoMarket: boolean;
    minimumEnrollmentOrderPv: number;
    isEnableForErAgreement: boolean;
    erAgreementAccepted?: boolean | undefined;
    isErAgreementDismissed?: boolean | undefined;
    scrollText?: string | undefined;
    agreementId?: string | undefined;
    isErAgreementDismissible?: boolean | undefined;
    text?: string | undefined;
    allowToBypassMeoRequirementWithPSK?: boolean | undefined;
}

export interface EnrollmentOrderInfoViewModel {
    starterKit?: ProductKit | undefined;
    additionalItems?: EnrollmentOrderItemViewModel[] | undefined;
    unavailableAdditionalItems?: EnrollmentOrderItemViewModel[] | undefined;
    erKit?: ProductKit | undefined;
    erAdditionalItems?: EnrollmentOrderItemViewModel[] | undefined;
    isEnrollingInEr?: boolean | undefined;
    minimumErPv: number;
    starterKitPv: number;
    additionalItemsTotalPv: number;
    erAdditionalItemsTotalPv: number;
    usePremiumStarterKitAsErOrder?: boolean | undefined;
    usePremiumStarterKitAsMeoOrder?: boolean | undefined;
    useFirsErOrderAsTemplate?: boolean | undefined;
    customErType?: CustomErType | undefined;
    voucherCodeDetails?: VoucherDetailsInfo | undefined;
}

export interface SocialLinkCreatorEntryViewModel {
    authToken?: AuthenticationToken | undefined;
    creatorLocale?: string | undefined;
    linkName?: string | undefined;
    templateId?: string | undefined;
    isEdit: boolean;
    voucherCodeDetails?: VoucherDetailsInfo | undefined;
}

export interface ThreeDSecureEntryViewModel {
    config?: ThreeDSecureConfigViewModel | undefined;
}

export interface ThreeDSecureConfigViewModel {
    addCard3dsEnabled: boolean;
    braintree3dsEnabled: boolean;
    cybersource3dsEnabled: boolean;
    chase3dsEnabled: boolean;
    doku3dsEnabled: boolean;
    sony3dsEnabled: boolean;
    stripe3dsEnabled: boolean;
    nuvei3dsEnabled: boolean;
    multiple3dsEnabled: boolean;
}

export interface StepModulesFormModel {
    enrollmentId: string;
    socialLinkEntry?: SocialLinkEntryForm | undefined;
    enrollmentKitSelection?: EnrollmentKitSelectionForm | undefined;
    accountCredentialsEntry?: AccountCredentialForm | undefined;
    erKitSelection?: ErKitSelectionForm | undefined;
    socialLinkErKitSelection?: ErKitSelectionForm | undefined;
    classicErKitSelection?: ErKitSelectionForm | undefined;
    nameEntry?: NameEntryForm | undefined;
    addressEntry?: AddressEntryForm | undefined;
    shippingAddressEntry?: ShippingAddressEntryForm | undefined;
    coApplicantEntry?: CoApplicantEntryForm | undefined;
    billingEntry?: BillingEntryForm | undefined;
    phoneEntry?: PhoneEntryForm | undefined;
    emailEntry?: EmailEntryForm | undefined;
    pinEntry?: PinEntryForm | undefined;
    studentEntry?: StudentEntryForm | undefined;
    governmentEntry?: GovernmentEntryForm | undefined;
    documentsUploadEntry?: DocumentsUploadEntryForm | undefined;
    genderEntry?: GenderEntryForm | undefined;
    shippingMethodSelection?: ShippingMethodSelectionForm | undefined;
    sponsorEnrollerEntry?: SponsorEnrollerEntryForm | undefined;
    ageEntry?: AgeEntryForm | undefined;
    memberAgreementEntry?: MemberAgreementForm | undefined;
    taxIdEntry?: TaxIdEntryForm | undefined;
    taxFormsAgreementEntry?: TaxFormsAgreementEntryForm | undefined;
    gstAgreementEntry?: GstAgreementForm | undefined;
    shareYoungLivingEntry?: ShareYoungingLivingForm | undefined;
    preferencesEntry?: PreferencesEntryForm | undefined;
    directMarketingAgreementEntry?: DirectMarketingAgreementForm | undefined;
    privacyPolicyAgreementEntry?: PrivacyPolicyAgreementForm | undefined;
    exceliaAgreementEntry?: ExceliaAgreementForm | undefined;
    confirmMemberInfoEntry?: ConfirmMemberInfoEntryForm | undefined;
    customerTypeEntry?: CustomerTypeEntryForm | undefined;
    phaseTag?: string | undefined;
}

export interface SocialLinkEntryForm {
    erAgreementAccepted?: boolean | undefined;
    isErAgreementDismissed?: boolean | undefined;
}

export interface EnrollmentKitSelectionForm {
    selectedKitId?: number | undefined;
}

export interface AccountCredentialForm {
    userName?: string | undefined;
    password?: string | undefined;
    isUsernameRequired: boolean;
}

export interface ErKitSelectionForm {
    usePremiumKitAsErOrder: boolean;
    useFirsErOrderAsTemplate?: boolean | undefined;
    selectedKitId?: number | undefined;
    isEnrollingInEr?: boolean | undefined;
    customErType?: CustomErType | undefined;
    erAgreementAccepted?: boolean | undefined;
    isErAgreementDismissed?: boolean | undefined;
    phaseTag?: string | undefined;
}

export interface ShippingAddressEntryForm {
    sameAsPrimaryAddress: boolean;
    address?: AddressEntryForm | undefined;
    isUsingWillCall: boolean;
    isUsingPickupPoint: boolean;
    isAusPost: boolean;
    isShiptoShop: boolean;
}

export interface BillingEntryForm {
    paymentType?: EnrollmentPaymentType | undefined;
    installment?: PaymentInstallment | undefined;
    creditCard?: CreditCardFormModel | undefined;
    sepa?: SepaFormModel | undefined;
    wireTransfer?: WireTransferFormModel | undefined;
    billingAddress?: BillingAddressFormModel | undefined;
    requestId?: string | undefined;
    deviceData?: string | undefined;
}

export interface SepaFormModel {
    firstNameOnAccount?: string | undefined;
    lastNameOnAccount?: string | undefined;
    iban?: string | undefined;
    agreementAccepted: boolean;
}

export interface BillingAddressFormModel {
    street1?: string | undefined;
    street2?: string | undefined;
    street3?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    stateProv?: string | undefined;
    postalCode?: string | undefined;
}

export interface EmailEntryForm {
    email?: string | undefined;
}

export interface PinEntryForm {
    pin?: string | undefined;
}

export interface StudentEntryForm {
    isStudent?: boolean | undefined;
}

export interface GovernmentEntryForm {
    governmentId?: string | undefined;
}

export interface DocumentsUploadEntryForm {
    uploadedDocumets?: DocumentInfoModel[] | undefined;
}

export interface GenderEntryForm {
    gender?: Gender | undefined;
}

export interface ShippingMethodSelectionForm {
    shippingId: number;
    deliveryTimeId?: number | undefined;
    willCallAddress?: AddressEntryForm | undefined;
    ausPostAddress?: AddressEntryForm | undefined;
    shipToShopAddress?: AddressEntryForm | undefined;
}

export interface SponsorEnrollerEntryForm {
    wasReferred: boolean;
    sponsorId: number;
    enrollerId: number;
    consentedToPlacementProgram: boolean;
    gaiyoshomenCode?: string | undefined;
}

export interface AgeEntryForm {
    birthdate?: string | undefined;
    isAgeCheckBoxSelected?: boolean | undefined;
}

export interface MemberAgreementForm {
    agreementAccepted: boolean;
}

export interface TaxFormsAgreementEntryForm {
    isAccepted: boolean;
}

export interface GstAgreementForm {
    agreementAccepted: boolean;
}

export interface ShareYoungingLivingForm {
    isSharingYoungLiving: boolean;
}

export interface PreferencesEntryForm {
    receiveEmail: boolean;
}

export interface DirectMarketingAgreementForm {
    agreementAccepted: boolean;
}

export interface PrivacyPolicyAgreementForm {
    agreementAccepted: boolean;
}

export interface ExceliaAgreementForm {
    agreementAccepted: boolean;
}

export interface ConfirmMemberInfoEntryForm {
    confirmed?: boolean | undefined;
}

export interface CustomerTypeEntryForm {
    selectedType: EnrollmentCustomerType;
}

export interface EnrollmentConfigViewModel {
    currency?: CurrencyViewModel | undefined;
    storeId: number;
    stepStyle: StepStyle;
    steps?: EnrollmentStepViewModel[] | undefined;
    languages?: StoreLanguage[] | undefined;
}

export enum StepStyle {
    Standard = "Standard",
    Accordion = "Accordion",
}

export interface EnrollmentStepViewModel {
    label?: string | undefined;
    id: number;
    layout: StepLayout;
    navigation?: StepNavigationViewModel | undefined;
    layoutModuleGroups?: LayoutGroupViewModel[] | undefined;
}

export enum StepLayout {
    Standard = "Standard",
    TwoColumn = "TwoColumn",
    ReviewPage = "ReviewPage",
    Accordion = "Accordion",
    PaymentFailure = "PaymentFailure",
}

export interface StepNavigationViewModel {
    nextLabel?: string | undefined;
    previousLabel?: string | undefined;
    justify?: string | undefined;
    nextStepModule?: EnrollmentModules | undefined;
    previousStepModule?: EnrollmentModules | undefined;
    hideNavigation: boolean;
}

export interface LayoutGroupViewModel {
    label?: string | undefined;
    modules?: EnrollmentModules[] | undefined;
}

export interface StoreLanguage {
    isoCode2?: string | undefined;
    locale?: string | undefined;
    languageIso?: string | undefined;
}

export interface UplineValidationStatus {
    enrollerName?: string | undefined;
    enrollerFirstName?: string | undefined;
    enrollerLastName?: string | undefined;
    enrollerStatus: UplineValidationStatuses;
    sponsorName?: string | undefined;
    sponsorFirstName?: string | undefined;
    sponsorLastName?: string | undefined;
    sponsorStatus: UplineValidationStatuses;
    isValid: boolean;
}

export enum UplineValidationStatuses {
    NotChecked = "NotChecked",
    Valid = "Valid",
    NotAHuman = "NotAHuman",
    HasntSignedDA = "HasntSignedDA",
    NoTaxId = "NoTaxId",
    NotFound = "NotFound",
    NotInUplineOfSponsor = "NotInUplineOfSponsor",
    Inactive = "Inactive",
    NotValidCustomerType = "NotValidCustomerType",
    NotAllowed = "NotAllowed",
    UnknownCountry = "UnknownCountry",
}

export interface EmailTakenFormModel {
    email?: string | undefined;
}

export interface TaxIdTakenFormModel {
    taxId?: string | undefined;
    taxIdTypeId: number;
}

export interface GovernmentIdTakenFormModel {
    taxId?: string | undefined;
    isGovernmentId: boolean;
}

export interface UserNameTakenFormModel {
    userName?: string | undefined;
}

export interface EnrollmentStatusFormModel {
    enrollmentId?: string | undefined;
    locale?: string | undefined;
    tag?: string | undefined;
    cartId?: string | undefined;
    countryIso?: string | undefined;
    sponsorId?: number | undefined;
    enrollerId?: number | undefined;
    doNotUpdate: boolean;
    countryIso3?: string | undefined;
    voucherCodeDetails?: VoucherDetailsInfo | undefined;
}

export interface CaptchaForm {
    token?: string | undefined;
}

export enum VirtualWalletType {
    NotSet = "NotSet",
    Paypal = "Paypal",
    Venmo = "Venmo",
    ApplePay = "ApplePay",
    GooglePay = "GooglePay",
    IDeal = "iDeal",
    NuveiPaymentPage = "NuveiPaymentPage",
    Bancontact = "Bancontact",
}

export interface AddPayPalFormModel {
    token?: string | undefined;
}

export interface TransactionStatusViewModel {
    id?: string | undefined;
    status: ValidateCreditCardAsyncStatus;
}

export enum ValidateCreditCardAsyncStatus {
    Failed = "Failed",
    Pending = "Pending",
    Succeed = "Succeed",
}

export interface ValidateCreditCardAsyncResponseViewModel {
    paymentMethodIdentity?: string | undefined;
    transactionId?: string | undefined;
    validateCreditCardAsyncStatus: ValidateCreditCardAsyncStatus;
    redirectionUrl?: string | undefined;
    paymentMethodProviderType?: PaymentMethodProviderType | undefined;
}

export interface CreditCartPreValidationForm {
    creditCard?: CreditCardFormModel | undefined;
    merchantSiteUrl?: string | undefined;
    requestId?: string | undefined;
}

export interface AssociateCvvWithCreditCardFormModel {
    encryptedCvv?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

/* eslint-disable @typescript-eslint/no-unused-vars */

const axios = {
  create: () => {
    throw new Error(
      'To support lazy loading, axios dependency is stubbed. ' +
        'Please create axios instance manually and pass to the constructor instead.'
    );
  }
};